/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiPointFromJSON, StreemApiPointToJSON, } from './';
export function WallItemARElementMeasurementFromJSON(json) {
    return WallItemARElementMeasurementFromJSONTyped(json, false);
}
export function WallItemARElementMeasurementFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'from': !exists(json, 'from') ? undefined : StreemApiPointFromJSON(json['from']),
        'to': !exists(json, 'to') ? undefined : StreemApiPointFromJSON(json['to']),
    };
}
export function WallItemARElementMeasurementToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'from': StreemApiPointToJSON(value.from),
        'to': StreemApiPointToJSON(value.to),
    };
}
//# sourceMappingURL=WallItemARElementMeasurement.js.map